module.exports = __webpack_public_path__ + "assets/img/00063.9dcb1219.png";